module.exports = __webpack_public_path__ + "img/clock-icon-white.c7f3a586.svg";